module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/25_5315c6f227d2d6de53c3bb6240bd08cc.jpg";